export default __webpack_public_path__ + "static/media/valutamarkets-light.26828867.png";